export default __webpack_public_path__ + "static/media/rightArrow.aed6ff06.svg";